import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseDialogComponent } from '../../../../base/dialog-base/dialog-base.component';

import { DialogService, UtilitaryService } from '../../../../services';

@Component({
    selector: 'form-dialog-errors',
    templateUrl: 'form-dialog-errors.component.html',
})
export class FormDialogErrorsComponent extends BaseDialogComponent implements OnInit {
    adresseValues: any = {};
    secteurs: any = [];
    errors: any[] = [];
    constructor(
        public dialogRef: MatDialogRef<FormDialogErrorsComponent>,
        private utilities: UtilitaryService,
        dialogService: DialogService,
        changeDetectorRef: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        super(dialogRef, dialogService, changeDetectorRef);
    }

    ngOnInit() {

        this.errors = this.data;
        this.utilities.log(this.data);
    }
}